// src/PrivacyPolicy.js

import React from "react";
import "./HomePage.css";
import SiteFooter from "./components/SiteFooter.js";
import PageHeader from "./components/PageHeader.js";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHeader />
    <main id="main-content" className="max-w-3xl mx-auto p-6 flex-1" tabIndex={-1}>
      <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">
        This Privacy Policy explains how we collect, use, and protect your
        information when you use our website or services. By accessing our
        platform, you agree to the practices described in this policy.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">1. Information We Collect</h2>
      <p className="mb-4">We may collect the following types of information:</p>
      <ul className="list-disc ml-6 space-y-2 mb-4">
        <li>Personal information (such as name, email, and contact details)</li>
        <li>Usage data (pages visited, actions taken, IP address)</li>
        <li>Device and browser information</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">2. How We Use Your Information</h2>
      <p className="mb-4">We use the collected information to:</p>
      <ul className="list-disc ml-6 space-y-2 mb-4">
        <li>Provide, maintain, and improve our services</li>
        <li>Respond to customer support requests</li>
        <li>Send updates or important notifications</li>
        <li>Monitor usage trends and performance</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">3. Sharing Your Information</h2>
      <p className="mb-4">
        We do not sell your personal information. We may share information with:
      </p>
      <ul className="list-disc ml-6 space-y-2 mb-4">
        <li>Trusted third-party service providers</li>
        <li>Legal authorities if required by law</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">4. Cookies</h2>
      <p className="mb-4">
        Our website may use cookies to enhance user experience, analyze trends,
        and improve functionality. You can disable cookies through your browser
        settings.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">5. Data Security</h2>
      <p className="mb-4">
        We take reasonable steps to protect your information from unauthorized
        access, disclosure, or misuse. However, no method of transmission over
        the internet is 100% secure.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">6. Your Rights</h2>
      <p className="mb-4">Depending on your region, you may have rights such as:</p>
      <ul className="list-disc ml-6 space-y-2 mb-4">
        <li>Accessing your personal data</li>
        <li>Requesting corrections or deletion</li>
        <li>Opting out of data collection or marketing</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">7. Changes to This Policy</h2>
      <p className="mb-4">
        We may update this Privacy Policy from time to time. Updated versions
        will be posted on this page with a revised “Last Updated” date.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">8. Contact Us</h2>
      <p className="mb-4">
        If you have questions or concerns about this Privacy Policy, contact us
        at:
      </p>

      <p className="font-semibold">hello@zolaid.com</p>

      <p className="text-sm text-gray-500 mt-8">Last Updated: January 2025</p>
    </main>
      <SiteFooter />
    </div>
  );
}
